import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface InfoPageProps {
  title: string;
  message: ReactNode;
  /** Иллюстрация 384×384 над заголовком. */
  illustration: ReactNode;
  /** Одна основная кнопка; при необходимости — второе действие текстовой кнопкой. */
  actions?: ReactNode;
}

/**
 * Блок информационной страницы. Типографика и отступы — те же, что у принятой
 * страницы 404 (`pages/not-found`), чтобы все такие страницы выглядели одинаково.
 */
export const InfoPage = ({
  title,
  message,
  illustration,
  actions,
}: InfoPageProps): JSX.Element => (
  <Box
    sx={{
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      maxWidth: "100%",
      textAlign: "center",
    }}
  >
    {illustration}
    <Typography
      variant="h4"
      component="h1"
      sx={{
        color: ({ palette }) => palette.text.primary,
        fontWeight: 400,
        letterSpacing: 0,
        lineHeight: "100%",
        mt: "20px",
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="h5"
      component="p"
      sx={{
        color: ({ palette }) => palette.text.primary,
        fontWeight: 400,
        letterSpacing: 0,
        lineHeight: "100%",
        mt: "18px",
      }}
    >
      {message}
    </Typography>
    {actions && (
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: 1,
          mt: "29px",
        }}
      >
        {actions}
      </Box>
    )}
  </Box>
);
